import React from "react";
import { useState } from "react";
import LoadingSpinner from "../../../components/Loadder";
import { getData, postData } from "../../../serverRequest";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function TaskForm(props) {
  const searchParams = new URLSearchParams(window.location.search);
  const [loading, setLoading] = useState(false);
  const taskId = searchParams.get('task_id');
  const [showModal, setShowModal] = useState(false);
  const [taskDate, setTaskDate] = useState();
  const [taskData, setTaskData] = useState();
  const [title, setTitle] = useState('Task title');
  const [description, setDescription] = useState('');
  const [taskDatatype, setTaskDatatype] = useState();
  const [assignedTo, setAssignedTo] = useState('');
  const [dueDate, setDueDate] = useState();
  const [taskStatus, setTaskStatus] = useState();
  const [admins, setAdmins] = useState([]);
  //const [isEditable, setIsEditable] = useState(false);

  const handleSubmit = async (event) => {
    //Prevent page reload
    setLoading(true);
    event.preventDefault();
    let reqData = {
      'task_id': taskId ? taskId : 0,  
      'status': taskStatus,
      'title': title,
      'description': description,
      'assigned_to_id': assignedTo,
      'due_date': dueDate ? dueDate : ''
    }

    let resData = await postData('/api/tasks/', reqData);
    if (resData['data']['code'] === 200) {
      setLoading(false);
      setShowModal(true);
      toast.success('Task submitted successfully!');  
      window.location.href = '/admin/tasks';
    
    } else {
      setLoading(false);
      toast.error('Failed to submit task. Please try again.');
    }
  };

  async function fetchData() {
    let resData = await getData('/api/employee/?company_id=1&is_list_employee=1');
    let admins_data = resData['data']['employee_data'];
    console.log(admins_data);
    setAdmins(admins_data ? admins_data : []); // Always set as array

    setLoading(false);
  }

  React.useEffect(() => {

    fetchData();


  }, [])

  return (
    <div className="task-form-container p-4 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* First Line: Title */}
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-1/12 px-4 mb-3">
                <div className="relative w-full mb-1">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Title</label>
                  <input type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    onC
                    name="title" defaultValue={title} />
                </div>
              </div>
            </div>
            {/* Second Line: Assigned To and Due Date */}
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4 mb-3">
                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Assigned To</label>
                <select
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  name="assigned_to"
                  value={assignedTo}
                  onChange={(e) => setAssignedTo(e.target.value)}
                >
                  <option value="">Select Admin</option>
                  {admins.map((admin) => (
                    <option key={admin.id} value={admin.id}>
                      {admin.first_name} {admin.last_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Due Date</label>
                  <DatePicker
                    selected={dueDate}
                    onChange={(date) => setDueDate(date)}
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  />
                </div>
              </div>
            </div>
            {/* Third Line: Description */}
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-10/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Description</label>
                  <textarea
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)} />
                </div>
              </div>
            </div>
            {/* Submit Button */}
            <div className="text-center mt-6 lg:w-3/12 px-4">
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit" />
            </div>
          </div>
        </form>
      )}
    </div>
  );
}
